import {LiveTableProps} from "../../../recebiveis/types";
import React, {useState} from "react";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import {TableContainer} from "../../../recebiveis/styles";
import Table, {TableColumn} from "../../../../../components/Table";
import {formatBrandView, formatDateView, formatMoneyView} from "../../../../../utils/formatViews";
import {formatAcquirer, formatTotal} from "../../../../../utils/generalFormat";

export const LiveTable: React.FC<LiveTableProps> =
  ({
     data,
     currentPage,
     pageSize,
     onPageChange,
     onPageSizeChange,
   }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <div>
      <LoadingOverlay
        show={isLoading}
        relative />

      <TableContainer>
        <Table
          dataSource={data.records}
          pagination={
            {
              defaultPageSize: pageSize,
              defaultCurrent: currentPage,
              current: currentPage,
              onShowSizeChange: (_, size) => {
                onPageSizeChange(size);
              },
              total: data.count,
              onChange: (pageNum) => onPageChange(pageNum),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} de ${total} vendas`,
            }}

        >
          <TableColumn title="Data Venda" dataIndex="paymentDateDate" key="paymentDateDate" render={formatDateView}/>
          <TableColumn title="Código EC" dataIndex="merchantId" key="merchantId" />
          <TableColumn title="NSU" dataIndex="acquirerNsu" key="acquirerNsu" />
          <TableColumn title="Nome" dataIndex="businessName" key="businessName" />
          <TableColumn title="Valor da Venda" dataIndex="value" key="value" render={formatMoneyView}/>
          <TableColumn title="Valor Liquido" dataIndex="liquidValue" key="liquidValue" render={formatMoneyView}/>
          <TableColumn title="Tipo Pagamento" dataIndex="productName" key="productName" />
          <TableColumn title="Total Parcelas" dataIndex="parcels" key="parcels" />
          <TableColumn title="Bandeira" dataIndex="brand" key="brand" render={formatBrandView}/>
          <TableColumn title="Adquirente" dataIndex="acquirer" key="acquirer" render={formatAcquirer}/>
          <TableColumn title="Custo MDR" dataIndex="itcPlusPrice" key="itcPlusPrice" render={formatMoneyView}/>
          <TableColumn title="Custo Antecipação" dataIndex="custoAntecipacao" key="custoAntecipacao" render={formatMoneyView}/>
          <TableColumn title="Custo Total Transação" dataIndex="custoTotalTransacao" key="custoTotalTransacao" render={formatMoneyView}/>
          <TableColumn title="Recebido Acquirer" dataIndex="valorRecebidoAcquirer" key="valorRecebidoAcquirer" render={formatMoneyView}/>
          <TableColumn title="Receita" dataIndex="receita" key="receita" render={formatMoneyView}/>
        </Table>

      </TableContainer>
    </div>
  )
}
